import type { GistItem } from "../../model/types";
import { useWorkspaceGistNavigation } from "../hooks/useWorkspaceGistNavigation";
import { isWorkspaceDraftGist } from "../model/getWorkspaceNavigationCounts";
import { WorkspaceGistTree } from "./WorkspaceGistTree";
import styles from "./WorkspaceGistNavigator.module.css";

export type WorkspaceGistNavigatorProps = {
  gists: GistItem[];
  currentGistId?: number | null;
  selectedSubjectId?: number | null;
  getGistHref?: (gist: GistItem) => string;
  onSelectGist?: (gist: GistItem) => void;
  onRequestHide?: () => void;
  sortGists?: (a: GistItem, b: GistItem) => number;
};

export function WorkspaceGistNavigator({
  gists,
  currentGistId,
  selectedSubjectId,
  getGistHref,
  onSelectGist,
  onRequestHide,
  sortGists,
}: WorkspaceGistNavigatorProps) {
  const { rows, counts } = useWorkspaceGistNavigation({
    gists,
    currentGistId,
    selectedSubjectId,
    sortGists,
  });

  return (
    <nav className={styles.navigator} aria-label="Workspace gist branch navigator">
      <div className={styles.header}>
        <div>
          <span className={styles.eyebrow}>Branch navigation</span>
          <h2 className={styles.title}>Gists in this branch</h2>
        </div>
        <div className={styles.headerActions}>
          <span className={styles.countBadge}>
            {counts.totalGists} {counts.totalGists === 1 ? "gist" : "gists"}
          </span>
          {onRequestHide && (
            <button
              type="button"
              className={styles.collapseButton}
              onClick={onRequestHide}
            >
              Hide
            </button>
          )}
        </div>
      </div>

      <WorkspaceGistTree
        rows={rows}
        getGistHref={getGistHref}
        isDraftGist={isWorkspaceDraftGist}
        onSelectGist={onSelectGist}
      />
    </nav>
  );
}
